import { render } from "./ChooseDelivery.vue?vue&type=template&id=5dea8859&scoped=true&ts=true"
import script from "./ChooseDelivery.vue?vue&type=script&lang=ts"
export * from "./ChooseDelivery.vue?vue&type=script&lang=ts"

import "./ChooseDelivery.vue?vue&type=style&index=0&id=5dea8859&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dea8859"]])

export default __exports__